import './styles/base.scss';
import VueCompositionApi from '@vue/composition-api';
import Vue from 'vue';
import DateUtils from './components/datepicker/dateUtils';
import * as OlbComponents from './components';
import { ResponsiveUtils, ScrollUtils } from './utils';
export * from './components';
export * from './utils';
export { DateUtils, ResponsiveUtils, ScrollUtils };
export default OlbComponents;

Vue.use(VueCompositionApi);
